module.exports = __webpack_public_path__ + "img/Maskan.188cb088.svg";